import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-645bc533"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "company-index-wrap" }
const _hoisted_2 = { class: "company-index-header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "company-index-header-x" }, null, -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 关注 ")
const _hoisted_5 = { class: "company-index-header-wz" }
const _hoisted_6 = { class: "company-index-header-content" }
const _hoisted_7 = { class: "company-index-header-ct" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = /*#__PURE__*/_createTextVNode("查看详情")
const _hoisted_10 = { class: "company-index-column" }
const _hoisted_11 = { class: "company-index-column-lt" }
const _hoisted_12 = { class: "company-index-column-rt" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "楼盘招商", -1))
const _hoisted_14 = {
  key: 0,
  class: "company-index-column-bt"
}
const _hoisted_15 = { class: "company-index-column-text" }
const _hoisted_16 = { class: "company-index-column-des" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "company-index-column-name" }, "招商会", -1))
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { class: "company-index-column-lt" }
const _hoisted_20 = { class: "company-index-column-rt" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "社区营销", -1))
const _hoisted_22 = {
  key: 0,
  class: "company-index-column-bt"
}
const _hoisted_23 = { class: "company-index-column-text" }
const _hoisted_24 = { class: "company-index-column-des" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "company-index-column-name" }, "招商会", -1))
const _hoisted_26 = { key: 1 }
const _hoisted_27 = { class: "company-index-column-lt" }
const _hoisted_28 = { class: "company-index-column-rt" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "样板房", -1))
const _hoisted_30 = {
  key: 0,
  class: "company-index-column-bt"
}
const _hoisted_31 = { class: "company-index-column-text" }
const _hoisted_32 = { class: "company-index-column-des" }
const _hoisted_33 = {
  key: 1,
  class: "company-index-column-nodata"
}
const _hoisted_34 = { class: "company-index-news" }
const _hoisted_35 = /*#__PURE__*/_createTextVNode("最新动态")
const _hoisted_36 = { class: "company-index-news-list" }
const _hoisted_37 = { class: "company-index-news-lt-hd" }
const _hoisted_38 = { class: "company-index-news-lt-info" }
const _hoisted_39 = { class: "company-index-news-lt-title" }
const _hoisted_40 = { class: "company-index-news-lt-des" }
const _hoisted_41 = { class: "company-index-news-lt-name" }
const _hoisted_42 = { class: "company-index-news-rt" }
const _hoisted_43 = ["onClick"]
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "company-index-news-rt-bg" }, null, -1))
const _hoisted_45 = { class: "company-index-news-rt-des" }

import Bottom from '../components/bottom.vue';
import store from '@/store/index';
import { useStore } from '@/store/index';
import { ref, reactive } from 'vue';
import tool from '@/utils/tool';
import router from '@/router/index';
import { ElButton, ElMessage, ElMessageBox } from 'element-plus';
import type { ElForm, Action } from "element-plus";

interface Company {
  id: string;
  type: number;
  code: string;
  name: string;
  shortName: string;
  licenseNo: string;
  licenseFile: string;
  logo: string;
  brandLogo: string;
  brandBigLogo: string;
  brandName: string;
  contact: string;
  mobile: string;
  tel: string;
  companyAreaIds: string;
  companyAreaIdList: string[];
  companyFace: string;
  remark: string;
  website: string;
  province: string;
  city: string;
  area: string;
  address: string;
  corporateRepresentative: string;
  registeredFund: number;
  industry: string;
  businessCategory: string;
  teamSize: number;
  handbagCertificateLevel: string;
  storefront: string;
  licenseFileFullPath: string;
  logoFullPath: string;
  brandBigLogoFullPath: string;
  brandLogoFullPath: string;
  areaId: string;
  isPublic: string;
}


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const loading = ref(true);
const ustore = useStore();

var id = router.currentRoute.value.params.id;

const company: Company = {
  id: "",
  type: 2,
  code: "",
  name: "",
  shortName: "",
  licenseNo: "",
  licenseFile: "",
  logo: "",
  brandLogo: "",
  brandBigLogo: "",
  brandName: "",
  contact: "",
  mobile: "",
  tel: "",
  companyAreaIds: "",
  companyAreaIdList: [],
  companyFace: "",
  remark: "",
  website: "",
  province: "",
  city: "",
  area: "",
  address: "",
  corporateRepresentative: "",
  registeredFund: 0,
  industry: "",
  businessCategory: "",
  teamSize: 0,
  handbagCertificateLevel: "",
  storefront: "",
  licenseFileFullPath: "",
  logoFullPath: "",
  brandBigLogoFullPath: "",
  brandLogoFullPath: "",
  areaId: "",
  isPublic: "",
};

const bindData = reactive({
  bbs: {
    name: "",
    companyName: "",
    projectName: "",
    status: 0,
    statusName: "",
  },
  invest: {
    name: "",
    companyName: "",
    projectName: "",
    status: 0,
    statusName: "",
  },
  room: {
    name: "",
    companyName: "",
    projectName: ""
  },
  companyInfo: company,
  pageParams: {
    curPage: 1,
    pageSize: 5,
    filtrate: {
      companyCode: id,
      status: "",
      keyword: "",
      types: "1,2",
      projectId: ''
    },
  },
  pageResult: {
    status: 2000,
    msg: "成功",
    result: [],
    totalCount: 0,
  },
  firstItem: {
    name: '',
    status: 0,
    statusName: '',
    thumbnailUrl: '',
    pushTime: '',
    province: '',
    city: '',
    area: '',
    address: '',
    projectName: '',
    companyName: '',
    imageList: [],
  },
  loginMember: ustore.state.loginMember == undefined ? {} : ustore.state.loginMember,
  isLogin: ustore.state.loginMember == undefined ? false : true,
});

store.dispatch("frontCompanyModule/getCompany", { companyCode: id }).then(
  (data) => {
    //成功
    bindData.companyInfo = data.result;
  },
  (error) => {
    ElMessageBox.alert(error.msg, "系统消息", {
      confirmButtonText: "关闭",
      callback: (action: Action) => { },
    });
  }
);

const handleToPage = (type: String) => {
  switch (type) {
    case 'invest':
      router.push('/company/invest/' + id)
      break;
    case 'community':
      router.push('/company/bbs/' + id)
      break;
    case 'room':
      router.push('/company/room/' + id)
      break;
  }
}

const goToDetail = () => {
  router.push('/company/detail/' + id);
}

const handleToDetail = (item: any) => {
  if (item.type == 1) {
    router.push('/frontDesk/fdInvestList/fdInvestDetail/' + item.id)
  }
  else {
    router.push('/frontDesk/bbsList/bbsDetail/' + item.id)
  }
}

const handleToRssActivity = () => {
  if (bindData.isLogin) {
    store
      .dispatch("frontCompanyModule/saveRssActivity", {
        rssCompanyId: bindData.companyInfo.id,
      })
      .then(
        (data) => {
          console.log(data);
          //成功
          ElMessage.success('订阅成功.');
        },
        (error) => {
          console.log(error.msg);
        }
      );
  }
  else {
    ElMessageBox.alert("请先登录...", '系统消息', {
      confirmButtonText: '确定',
      callback: (action: Action) => {
        if (action == "confirm") {
          router.push('/frontDesk/login')
        }
      },
    });
  }
}

store
  .dispatch("frontCompanyModule/pageActivityList", {
    curPage: 1,
    pageSize: 1,
    filtrate: {
      companyCode: id,
      status: "",
      keyword: "",
      type: "1",
      projectId: ''
    },
  })
  .then(
    (data) => {
      console.log(data);
      //成功
      for (var index in data.result) {
        const obj = data.result[index];
        switch (obj.status) {
          // case 1:
          //   obj.statusName = "草稿";
          //   break;
          // case 2:
          //   obj.statusName = "待审核";
          //   break;
          case 3:
            obj.statusName = "即将开始";
            break;
          case 4:
            obj.statusName = "报名中";
            break;
          case 5:
            obj.statusName = "已开始";
            break;
          case 6:
            obj.statusName = "已结束";
            break;
          // case 7:
          //   obj.statusName = "已取消";
          //   break;
          default:
            obj.statusName = "--";
            break;
        }
      }
      if (data.result.length > 0) {
        bindData.invest = data.result[0];
      }
    },
    (error) => {
      console.log(error.msg);
    }
  );

store
  .dispatch("frontCompanyModule/pageActivityList", {
    curPage: 1,
    pageSize: 1,
    filtrate: {
      companyCode: id,
      status: "",
      keyword: "",
      type: "2",
      projectId: ''
    },
  })
  .then(
    (data) => {
      console.log(data);
      //成功
      for (var index in data.result) {
        const obj = data.result[index];
        switch (obj.status) {
          // case 1:
          //   obj.statusName = "草稿";
          //   break;
          // case 2:
          //   obj.statusName = "待审核";
          //   break;
          case 3:
            obj.statusName = "即将开始";
            break;
          case 4:
            obj.statusName = "报名中";
            break;
          case 5:
            obj.statusName = "已开始";
            break;
          case 6:
            obj.statusName = "已结束";
            break;
          // case 7:
          //   obj.statusName = "已取消";
          //   break;
          default:
            obj.statusName = "--";
            break;
        }
      }
      if (data.result.length > 0) {
        bindData.bbs = data.result[0];
      }
    },
    (error) => {
      console.log(error.msg);
    }
  );

store
  .dispatch(
    'frontCompanyModule/pagePrototypeRoomList',
    {
      curPage: 1,
      pageSize: 1,
      filtrate: {
        companyCode: id,
        keyword: '',
      },
    }
  )
  .then(
    (data) => {
      //成功
      if (data.result.length > 0) {
        bindData.room = data.result[0]
      }
    },
    (error) => {
      console.log(error.msg);
    }
  );

const searchEvent = () => {
  loading.value = true;
  store
    .dispatch("frontCompanyModule/pageActivityList", bindData.pageParams)
    .then(
      (data) => {
        console.log(data);
        //成功
        for (var index in data.result) {
          const obj = data.result[index];
          switch (obj.status) {
            // case 1:
            //   obj.statusName = "草稿";
            //   break;
            // case 2:
            //   obj.statusName = "待审核";
            //   break;
            case 3:
              obj.statusName = "即将开始";
              break;
            case 4:
              obj.statusName = "报名中";
              break;
            case 5:
              obj.statusName = "已开始";
              break;
            case 6:
              obj.statusName = "已结束";
              break;
            // case 7:
            //   obj.statusName = "已取消";
            //   break;
            default:
              obj.statusName = "--";
              break;
          }
        }

        loading.value = false;
        if (data.result.length > 0) {
          bindData.firstItem = data.result[0];
        }
        //删除第一个元素
        data.result.shift();
        bindData.pageResult = data;
      },
      (error) => {
        console.log(error.msg);
      }
    );
};

searchEvent();


return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_arrow_right_bold = _resolveComponent("arrow-right-bold")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_image, {
        src: require('@/assets/fd/company/u1348.jpg')
      }, null, 8, ["src"]),
      _createVNode(_component_el_container, { class: "company-index-header-hd" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_image, {
            fit: "fill",
            class: "company-index-header-logo1",
            src: require('@/assets/fd/company/u684.png')
          }, null, 8, ["src"]),
          _hoisted_3,
          _createVNode(_component_el_image, {
            fit: "fill",
            class: "company-index-header-logo2",
            src: _unref(bindData).companyInfo.brandLogoFullPath
          }, null, 8, ["src"]),
          _createElementVNode("div", null, [
            _createElementVNode("div", {
              class: "company-index-header-name",
              onClick: goToDetail
            }, _toDisplayString(_unref(bindData).companyInfo.name), 1),
            _createVNode(_component_el_container, {
              class: "company-index-header-collect",
              onClick: handleToRssActivity
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_image, {
                  fit: "fill",
                  class: "company-index-header-collect-icon",
                  src: require('@/assets/fd/company/u1493.png')
                }, null, 8, ["src"]),
                _hoisted_4
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", {
              innerHTML: _unref(bindData).companyInfo.remark
            }, null, 8, _hoisted_8)
          ]),
          _createVNode(_component_el_container, { class: "company-index-header-btn" }, {
            default: _withCtx(() => [
              _createVNode(_unref(ElButton), {
                type: "primary",
                onClick: goToDetail
              }, {
                default: _withCtx(() => [
                  _hoisted_9
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(_component_el_container, { class: "company-index-column-line" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_el_image, {
              fit: "fill",
              class: "company-index-column-icon",
              src: require('@/assets/fd/company/u1455.png')
            }, null, 8, ["src"])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_el_container, {
              class: "company-index-column-title",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (handleToPage('invest')))
            }, {
              default: _withCtx(() => [
                _hoisted_13,
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_arrow_right_bold)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (_unref(bindData).invest.name.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createTextVNode(_toDisplayString(_unref(bindData).invest.companyName || "--"), 1),
                    _createElementVNode("span", _hoisted_16, "•" + _toDisplayString(_unref(bindData).invest.name || "--"), 1)
                  ]),
                  _createVNode(_component_el_container, { class: "company-index-column-btn" }, {
                    default: _withCtx(() => [
                      _hoisted_17
                    ]),
                    _: 1
                  })
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_18, "暂无内容"))
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_el_container, { class: "company-index-column-line" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_19, [
            _createVNode(_component_el_image, {
              fit: "fill",
              class: "company-index-column-icon",
              src: require('@/assets/fd/company/u1468.png')
            }, null, 8, ["src"])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createVNode(_component_el_container, {
              class: "company-index-column-title",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (handleToPage('bbs')))
            }, {
              default: _withCtx(() => [
                _hoisted_21,
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_arrow_right_bold)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (_unref(bindData).bbs.name.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _createTextVNode(_toDisplayString(_unref(bindData).bbs.projectName || "--"), 1),
                    _createElementVNode("span", _hoisted_24, "•" + _toDisplayString(_unref(bindData).bbs.name || "--"), 1)
                  ]),
                  _createVNode(_component_el_container, { class: "company-index-column-btn" }, {
                    default: _withCtx(() => [
                      _hoisted_25
                    ]),
                    _: 1
                  })
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_26, "暂无内容"))
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_el_container, { class: "company-index-column-line" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_27, [
            _createVNode(_component_el_image, {
              fit: "fill",
              class: "company-index-column-icon",
              src: require('@/assets/fd/company/u1402.png')
            }, null, 8, ["src"])
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createVNode(_component_el_container, {
              class: "company-index-column-title",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (handleToPage('room')))
            }, {
              default: _withCtx(() => [
                _hoisted_29,
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_arrow_right_bold)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (_unref(bindData).room.name.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    _createTextVNode(_toDisplayString(_unref(bindData).room.projectName || "--"), 1),
                    _createElementVNode("span", _hoisted_32, "•" + _toDisplayString(_unref(bindData).room.name || "--"), 1)
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_33, "暂无内容"))
          ])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_34, [
      _createVNode(_component_el_container, { class: "company-index-divider" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_divider, { "content-position": "center" }, {
            default: _withCtx(() => [
              _hoisted_35
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_36, [
        _createVNode(_component_el_container, { class: "company-index-news-item" }, {
          default: _withCtx(() => [
            (_unref(bindData).firstItem.name.length > 0)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "company-index-news-lt",
                  onClick: _cache[3] || (_cache[3] = () => handleToDetail(_unref(bindData).firstItem))
                }, [
                  _createElementVNode("div", _hoisted_37, [
                    _createVNode(_component_el_carousel, {
                      class: "bbs-detail-ad",
                      height: "200px"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).firstItem.imageList, (image) => {
                          return (_openBlock(), _createBlock(_component_el_carousel_item, {
                            key: image.id,
                            style: {"display":"flex","justify-content":"center"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_image, {
                                class: "company-index-news-lt-banner",
                                mode: "widthfix",
                                src: image.imgUrl
                              }, null, 8, ["src"])
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("div", _hoisted_39, _toDisplayString(_unref(bindData).firstItem.name || "--"), 1),
                    _createElementVNode("div", _hoisted_40, _toDisplayString(_unref(bindData).firstItem.province) + "，" + _toDisplayString(_unref(bindData).firstItem.city) + "，" + _toDisplayString(_unref(bindData).firstItem.area) + "，" + _toDisplayString(_unref(bindData).firstItem.address), 1),
                    _createElementVNode("div", _hoisted_41, _toDisplayString(_unref(bindData).firstItem.projectName || "--") + " | " + _toDisplayString(_unref(bindData).firstItem.companyName || "--"), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_42, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).pageResult.result, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "company-index-news-rt-item",
                  key: item.id,
                  onClick: () => handleToDetail(item)
                }, [
                  _createVNode(_component_el_carousel, {
                    class: "bbs-detail-ad",
                    height: "200px"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.imageList, (image) => {
                        return (_openBlock(), _createBlock(_component_el_carousel_item, {
                          key: image.id,
                          style: {"display":"flex","justify-content":"center"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_image, {
                              class: "company-index-news-rt-banner",
                              mode: "widthfix",
                              src: image.thumbnailUrl
                            }, null, 8, ["src"])
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 2
                  }, 1024),
                  _hoisted_44,
                  _createElementVNode("div", _hoisted_45, _toDisplayString(item.name || "--"), 1)
                ], 8, _hoisted_43))
              }), 128))
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(Bottom, { class: "company-index-bottom" })
  ]))
}
}

})